import { authApi } from '@/api/auth';

const state = {
  user: JSON.parse(localStorage.getItem('nexyo_user') || 'null'),
  token: localStorage.getItem('nexyo_token') || null,
  refreshToken: localStorage.getItem('nexyo_refresh_token') || null,
};

const getters = {
  isAuthenticated: (s) => !!s.token,
  user: (s) => s.user,
  token: (s) => s.token,
  refreshToken: (s) => s.refreshToken,
  role: (s) => s.user?.role || null,
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
    if (user) localStorage.setItem('nexyo_user', JSON.stringify(user));
    else localStorage.removeItem('nexyo_user');
  },
  SET_TOKEN(state, token) {
    state.token = token;
    if (token) localStorage.setItem('nexyo_token', token);
    else localStorage.removeItem('nexyo_token');
  },
  SET_REFRESH_TOKEN(state, refreshToken) {
    state.refreshToken = refreshToken;
    if (refreshToken) localStorage.setItem('nexyo_refresh_token', refreshToken);
    else localStorage.removeItem('nexyo_refresh_token');
  },
  LOGOUT(state) {
    state.user = null;
    state.token = null;
    state.refreshToken = null;
    localStorage.removeItem('nexyo_user');
    localStorage.removeItem('nexyo_token');
    localStorage.removeItem('nexyo_refresh_token');
  },
};

const actions = {
  async login({ commit }, { email, password }) {
    const { data } = await authApi.login(email, password);
    commit('SET_TOKEN', data.access_token);
    commit('SET_REFRESH_TOKEN', data.refresh_token || null);
    commit('SET_USER', data.user);
    return data;
  },
  async register({ commit }, payload) {
    const { data } = await authApi.register(payload);
    commit('SET_TOKEN', data.access_token);
    commit('SET_REFRESH_TOKEN', data.refresh_token || null);
    commit('SET_USER', data.user);
    return data;
  },
  async refreshSession({ commit, state }) {
    if (!state.refreshToken) throw new Error('No hay refresh token');
    const { data } = await authApi.refresh(state.refreshToken);
    commit('SET_TOKEN', data.access_token);
    commit('SET_REFRESH_TOKEN', data.refresh_token || null);
    commit('SET_USER', data.user);
    return data;
  },
  async fetchUser({ commit }) {
    const { data } = await authApi.getProfile();
    commit('SET_USER', data);
    return data;
  },
  async logout({ commit }) {
    try {
      await authApi.logout();
    } catch {
      // Ignorar fallo remoto y limpiar sesión local.
    }
    commit('LOGOUT');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
